let t = "http://img.fengbolive.com/pic/avatar/{0}_{1}_200*200.jpg"
let ANCHOR_SORT_BASE = 100

const state = {
    anchorList: [],
    mapAnchorIdToInfo: {},
    currentAnchorId: 0,
    currentPage:0,
}

// this message is similar to send message. It's sync
const mutations = {
    ANCHORLISTDATA_UPDATE_ANCHORLIST(state, data) {
        if (null == data) {
            state.anchorList = [];
            state.mapAnchorIdToInfo = {};
            return;
        }
        state.currentPage = data.page;
        let ls = state.anchorList;
        let lsSrc = data.info;
        let info, url = null;
        for (let i = 0; i < lsSrc.length; i++) {
            info = lsSrc[i];
            let storeinfo = state.mapAnchorIdToInfo[info.id];
            if (storeinfo) {
                continue;
            }
            if (info.stype == 1) {//只显示视频房间 1为视频 2位语音 3为星座
                if (info.phid == 0) {
                    info['img'] = "http://img.fengbolive.com/pic/avatar/default.png";
                } else if(info.phid == 1){
                    info['img'] = "http://img.fengbolive.com/pic/avatar/smallHeadForAuthFail.png";
                } else {
                    info['img'] = t.format(info.id, info.phid);
                }
                info['name'] = decodeURI(info.name)
                url = info.url;
                if (url) {
                    if (url.indexOf('hdlws.sinashow.com') > 0) {
                        //var state = 0;
                        
                        //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                        //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else {
                        //var state = 1;
                        //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
                        info['url'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    }
                }else{
                    info['url'] ="";
                }
                url = info.micUrl;
                if (url) {
                    if (url.indexOf('hdlws.sinashow.com') > 0) {
                        //var state = 0;
                        
                        //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['micUrl'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                        //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['micUrl'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else {
                        //var state = 1;
                        //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
                        info['micUrl'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    }
                }else{
                    info['micUrl'] ="";
                }

                url = info.security_url;
                
                if (url) {
                    if (url.indexOf('hdlws.sinashow.com') > 0) {
                        //var state = 0;
                        //info['url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['security_url'] = url.replace('hdlws.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else if (url.indexOf('hdlnew.sinashow.com') > 0) {
                        //info['url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                        info['security_url'] = url.replace('hdlnew.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    } else {
                        //var state = 1;
                        //info['url'] = url.replace('hdlks.sinashow.com', 'hlsks.sinashow.com').replace('.flv', '/index.m3u8');
                        info['security_url'] = url.replace('hdlks.sinashow.com', 'hlsws.sinashow.com').replace('.flv', '/playlist.m3u8');
                    }
                }else{
                    info['security_url'] ="";
                }
                info['sortValue'] = ANCHOR_SORT_BASE * data.page + i;
                ls.push(info);
                //将数据存入映射当中
                state.mapAnchorIdToInfo[info.id] = info
            }
        
        }
    },
    ANCHORLISTDATA_REMOVE_BY_ID(state, anchordId) {
        state.mapAnchorIdToInfo[anchordId] = null;
        let newList = [];
        for (let index = 0; index < state.anchorList.length; index++) {
            const element = state.anchorList[index];
            if (element.id == anchordId) {
                continue;
            }
            newList.push(element);
        }
        state.anchorList = newList.slice();
    }
}

// this message is similar to post message. It's async
const actions = {
    upDataAnchorListData({
        state,
        commit
    },
    data){
        commit('ANCHORLISTDATA_UPDATE_ANCHORLIST', data)
    }
}

const getters = {
    getAnchorInfoByID: (state) => (id) => {
        let b = state.mapAnchorIdToInfo[id];
        if (b == null) {
            b = state.anchorList.find((e) => (e.id == id))
        }
        return b
    },
    getAnchorSeverInfoByID: (state) => (id) => {
        let anchorInfo = state.mapAnchorIdToInfo[id];
        if (!anchorInfo) {
            return null;
        }
        let sInfo = anchorInfo.ip;
        for (let index = 0; index < sInfo.length; index++) {
            const element = sInfo[index];
            if (element.isp == 3) {
                return sInfo[index];
            }
        }
        return sInfo[0];
    },
}

export default {
    state,
    mutations,
    actions,
    getters
}